import styled from "styled-components";

export const CsvButton = styled.div`
    a{
    color: #fff;
    border-radius: 50rem;
    font-size: 18px;
    font-weight: 500;
    &:hover{
        text-decoration:none;
        color: #8cc63f;
    }
    }
`;




// WEBPACK FOOTER //
// ./src/views/dashboard/styles.js